import * as React from "react";
import {Link} from "react-router-dom";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {resourcesHelper} from "@falcon/services";

interface IState {
    showPopup: boolean;
}

interface IProps {
    premiumType: string;
    policyNumber: string
}

export class ChargebackBanner extends React.Component<IProps, IState> {

    constructor(props: any) {
        super(props);

        this.state = {
            showPopup: false
        };

        this.toggle = this.toggle.bind(this);
    }

    public render() {
        const closeBtn = <button className="btn-close" onClick={this.toggle}/>
        const linkPath = {
            pathname: `/dashboard/account/startPayment/${this.props.policyNumber}`,
            state: {
                returnUrl: window.location.pathname,
                invoiceType: "CHARGEBACK",
                description: "Chargeback payment"
            }
        };
        return (
            <>
                <div className="banner">
                    <img src={`/${resourcesHelper.THEME}/img/alert-blue.svg`} alt="Blue alert icon"/>
                    <div className="banner-text">
                        This policy is scheduled for cancellation. Your account is now in debt and whilst this is investigated no changes will be allowed.{" "}
                        <Link onClick={this.toggle} to="#" id="readMore"
                              aria-label={"Read more"}>Read more</Link>
                    </div>
                    <Modal className="falcon-modal" isOpen={this.state.showPopup} toggle={this.toggle}>
                        <ModalHeader toggle={this.toggle} close={closeBtn}/>
                        <ModalBody className="pt-0 overflow-auto">
                            <img src={`/${resourcesHelper.THEME}/img/alert-blue.svg`} alt="Blue alert icon"/>
                            <p className="d-inline mt-0 mb-2 ml-3 mr-3 font-weight-bold fs-24">This policy is scheduled for cancellation!</p>
                            <p className="pt-3 mb-1">We have been notified that a chargeback claim has been made against a payment card registered to this policy.</p>
                            <p>This means this account is now in arrears and whilst this is investigated no changes will be allowed. If this claim has been made in error then please '<Link className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16" to={linkPath} id="payNow" aria-label={"Pay Now"}>Pay Now</Link>' to stop further action being taken.</p>
                            <div className="justify-content-center">
                                <div className="row m-0">
                                    <Link className="btn btn-primary btn-next-no-arrow btn-wide mt-1 mb-2" to={linkPath}>Make a one-off payment</Link>
                                </div>
                                <div className="row m-0">
                                    <button onClick={this.toggle} type="button" className="btn btn-back btn-wide plugin mt-1 mb-2">Cancel</button>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                </div>
            </>
        );
    }

    private toggle(): void {
        this.setState((state: IState) => ({
            showPopup: !state.showPopup
        }));
    }

}



// WEBPACK FOOTER //
// ./src/components/banners/ChargebackBanner.tsx